import { coversAccessLevel } from './accessLevel';

/** What the router guard does with a route under the role matrix (plan 2026-10-supplier-access). */
export const ACCESS_ROUTE_DECISION = {
  /**
   * Switch off or no `accessNodeId`: the old checks of the route decide (not for `isMatrixOnly`;
   * `isLegacyOnly` with the switch on is denied).
   */
  LEGACY: 'legacy',
  /** `myAccess` is needed and not loaded yet. */
  LOAD: 'load',
  ALLOW: 'allow',
  DENY: 'deny',
};

function accessRecordOf(route) {
  return route.matched.find((record) => record.meta.accessNodeId);
}

/** `access`: isSwitchOn, isMyAccessLoaded, hasMyAccessError, getAccessLevel(nodeId). */
export function decideAccessRoute(route, access) {
  const accessRecord = accessRecordOf(route);
  // Matrix-only unit (ADR 0004 addendum "Matrix-only units"): no legacy checks, Legacy-Authz denies.
  if (!access.isSwitchOn && accessRecord?.meta.isMatrixOnly) {
    return ACCESS_ROUTE_DECISION.DENY;
  }
  // Legacy-only page: Matrix-Authz denies, the old checks apply in Legacy-Authz only.
  if (access.isSwitchOn && route.matched.some((record) => record.meta.isLegacyOnly)) {
    return ACCESS_ROUTE_DECISION.DENY;
  }
  if (!access.isSwitchOn || !accessRecord) {
    return ACCESS_ROUTE_DECISION.LEGACY;
  }
  if (access.hasMyAccessError) {
    return ACCESS_ROUTE_DECISION.DENY;
  }
  if (!access.isMyAccessLoaded) {
    return ACCESS_ROUTE_DECISION.LOAD;
  }

  const { accessNodeId, requiredAccessLevel } = accessRecord.meta;
  return coversAccessLevel(access.getAccessLevel(accessNodeId), requiredAccessLevel)
    ? ACCESS_ROUTE_DECISION.ALLOW
    : ACCESS_ROUTE_DECISION.DENY;
}
